import { useEffect, useState } from 'react';
import { FlexContainer, Spinner } from '@taxdown/piccolo-web';
import { history } from 'Store';
import { useFlags } from 'Hooks/useFlags';
import OneColLayout from 'Components/Layouts/OneColLayout';
import { routes } from 'Constants/routes';
import { FlagsKey } from 'Types/common';
import Header from './components/Header';
import Questions from './components/Questions';
import ReferralTracking from './components/ReferralTracking';
import { useFetchGetProfitsReferral, useFetchGetReferralLinks } from './hooks';

const Referral = (): JSX.Element => {
  const { enabled } = useFlags(FlagsKey.MGM_FLOW_ENABLED);
  const [hasReferral, setHasReferral] = useState<boolean>(false);
  const { data, isLoading, refetch } = useFetchGetReferralLinks();
  const { data: profits, isLoading: loading } = useFetchGetProfitsReferral();

  useEffect(() => {
    if (enabled) {
      history.push(routes.DASHBOARD);
    }
  }, [enabled]);

  useEffect(() => {
    if (profits) {
      setHasReferral(
        Object.keys(profits)
          .filter(profit => profit !== 'profits')
          .some(profit => profits[profit]?.names?.length > 0)
      );
    }
  }, [profits]);

  if (isLoading && loading && !data) {
    return (
      <OneColLayout>
        <FlexContainer align="center" justify="center">
          <Spinner size="L" align="center" justify="center" />
        </FlexContainer>
      </OneColLayout>
    );
  }
  return (
    <OneColLayout>
      {data && profits && (
        <>
          <Header hasReferral={hasReferral} referralLinks={data.links} />
          <ReferralTracking
            referralData={data}
            profits={profits}
            hasReferral={hasReferral}
            refetch={refetch}
          />
          <Questions />
        </>
      )}
    </OneColLayout>
  );
};

export default Referral;
